import { useMutation, type UseMutationResult } from '@tanstack/react-query';

const useRenewalMutation = (): UseMutationResult<UseMutationResult, unknown, string | null> => {
    const endpoint = '/api/Members/current/renewalnotice';

    const submitForm = useMutation({
        mutationFn: async(renewalDeliveryMethod: string | null): Promise<UseMutationResult> => {
            const response = await fetch(endpoint, {
                method: 'PUT',
                body: JSON.stringify({ renewalDeliveryMethod }),
                headers: { 'Content-Type': 'application/json' },
            });

            if (!response.ok) {
                if (response.status === 400) {
                    const errorResponse = await response.json();
                    throw new Error(errorResponse.errorMessage?.[0] ?? 'Unknown error');
                }

                throw new Error('Unable to submit form');
            }

            const responseData = await response.json();

            if (!responseData.isSuccess) {
                throw new Error(`Form submission failed: ${responseData.errorMessage?.[0] ?? 'Unknown error'}`);
            }

            return responseData.data;
        },
    });

    return submitForm;
};

export default useRenewalMutation;
